import { makeStyles } from '@material-ui/core/styles';

export const useFormCreateRequestStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  },
  requestTypesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  }
}));
